import { Box, Paper, Skeleton, Stack } from "@mui/material";
import Divider from "@mui/material/Divider";

const BranchSkeleton = () => {
  return (
    <Paper
      elevation={0}
      sx={{ borderRadius: "25px", padding: "24px 28px 24px 24px" }}
    >
      <Stack spacing={2}>
        <Skeleton width={320} height={32} />
        <Divider variant="middle" />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeleton
            // width={360}
            height={32}
            sx={{
              width: { xs: 100, sm: 120, lg: 360 },
              // height: 32,
            }}
          />
          <Skeleton variant="rounded" width={157} height={36} />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
            }}
          >
            <Skeleton variant="rounded" width={86} height={30} />
          </Box>
          <Box sx={{ display: "flex" }}>
            <Skeleton
              sx={{
                mr: 2,
                width: { xs: 149, sm: 157 },
                // height: 32,
              }}
              variant="rounded"
              // width={157}
              height={36}
            />
            <Skeleton
              variant="rounded"
              sx={{
                mr: 2,
                width: { xs: 148, sm: 157 },
                // height: 32,
              }}
              // width={157}
              height={36}
            />
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};

export default BranchSkeleton;
